import {useMutation} from 'react-query';

import patchUserPromotedRequirement from '.';
import {AxiosError} from 'axios';
import {toast} from 'react-toastify';
interface IusePatchUserPromotedRequirementProps {
  onSuccess?: () => void;
}
const usePatchUserPromotedRequirement = ({
  onSuccess,
}: IusePatchUserPromotedRequirementProps) => {
  const {isLoading, mutate} = useMutation({
    mutationFn: (guid: string) => patchUserPromotedRequirement(guid),
    onSuccess: () => {
      onSuccess && onSuccess();
    },
    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });
  return {isLoading, PatchUserPromotedRequirementMutate: mutate};
};

export default usePatchUserPromotedRequirement;
